<template>
  <div>
    <Breadcrumbs main="Dashboard" title="Dashboard" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pt-4 px-3 pb-0">
                <div class="media">
                  <div class="media-body p-0">
                    <h6 style="font-weight:300;">Total Candidate Applied</h6>
                    <h3>{{ dataHeader.total_candidate }}</h3>  
                  </div>
                </div>
              </div>
              <div>
                <div id="chart-widget1">
                  <apexchart
                    height="60"
                    type="area"
                    :options="chart1.options"
                    :series="chart1.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-3 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pt-4 px-3 pb-0">
                <div class="media">
                  <div class="media-body">
                    <h6 style="font-weight:300;">Total Registration</h6>
                    <h3>{{ dataHeader.total_registration }}</h3>  
                  </div>
                  <h6 class="num total-value font-success pr-2">
                    +65
                  </h6>
                </div>
              </div>
              <div>
                <div id="chart-widget1">
                  <apexchart
                    height="60"
                    type="area"
                    :options="chart1.options"
                    :series="chart1.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-3 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pt-4 px-3 pb-0">
                <div class="media">
                  <div class="media-body">
                    <h6 style="font-weight:300;">Total In Progress</h6>
                    <h3>{{ dataHeader.total_inprogress }}</h3>  
                  </div>
                  <h6 class="num total-value font-success pr-2">
                    +65
                  </h6>
                </div>
              </div>
              <div>
                <div id="chart-widget1">
                  <apexchart
                    height="60"
                    type="area"
                    :options="chart1.options"
                    :series="chart1.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-3 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pt-4 px-3 pb-0">
                <div class="media">
                  <div class="media-body">
                    <h6 style="font-weight:300;">Finish Assessment</h6>
                    <h3>{{ dataHeader.total_finish }}</h3>  
                  </div>
                  <h6 class="num total-value font-success pr-2">
                    +65
                  </h6>
                </div>
              </div>
              <div>
                <div id="chart-widget1">
                  <apexchart
                    height="60"
                    type="area"
                    :options="chart1.options"
                    :series="chart1.series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
      </div>
     <div class="row ">

        <div class="col-xl-12 xl-100 dashboard-sec box-col-12">
          <px-card class="earning-card" title="Candidate Registration">
              <div class="row m-0">
                <div class="col-xl-12 p-0">
                  <div class="chart-right">
                    <div class="row m-0 p-tb">
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="card-body p-0">
                          <div class="current-sale-container">
                            <div id="chart-currently">
                              <apexchart
                                height="320"
                                type="area"
                                :options="chart11.options"
                                :series="chart11.series"
                              ></apexchart>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row border-top m-0">
                    <div class="col-xl-4 pl-0 col-md-6 col-sm-6">
                      <div class="media p-0">
                        <div class="media-left">
                          <i class="icofont icofont-crown"></i>
                        </div>
                        <div class="media-body">
                          <h6>Sekolah</h6>
                          <p>30 Sekolah</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-md-6 col-sm-6">
                      <div class="media p-0">
                        <div class="media-left bg-secondary">
                          <i class="icofont icofont-heart-alt"></i>
                        </div>
                        <div class="media-body">
                          <h6>Usia</h6>
                          <p>19 Thn</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-md-12 pr-0">
                      <div class="media p-0">
                        <div class="media-left">
                          <i class="icofont icofont-cur-dollar"></i>
                        </div>
                        <div class="media-body">
                          <h6>Job Experience</h6>
                          <p>5 Thn</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </px-card>
        </div>
     </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
  var primary = localStorage.getItem('primary_color') || '#096358';
  // var secondary = localStorage.getItem('secondary_color') || '#f73164';

  export default {
    data() {
      return {
        dataHeader: {
          total_candidate : 0,
          total_registration: 0,
          total_inprogress: 0,
          total_finish: 0
        },
        chart11: {
          options: {
            chart: {
              width: '100%',
              type: 'area',
              toolbar: {
                show: false,
              },
            },
            colors: [primary],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
              width: 2,
            },
            xaxis: {
              show: true,
              categories: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Des',
                'Des',
              ],
            },
            fill: {
              colors: [primary],
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm',
              },
            },
            grid: {
              yaxis: {
                show: false,
              },
              padding: {
                right: 0,
              },
            },
          },
          series: [
            {
              name: 'series1',
              data: [0,0,0,0,0,120,0,0,0,0,0,0],
            },
          ],
        },
        chart1: {
          options: {
            chart: {
              width: 510,
              height: 190,
              type: 'area',
              toolbar: {
                show: false,
              },
            },
            colors: ['#f73164'],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
              width: 2,
            },
            xaxis: {
              show: false,
              type: 'datetime',
              categories: [
                '2018-09-19T00:00:00',
                '2018-09-19T01:30:00',
                '2018-09-19T02:30:00',
                '2018-09-19T03:30:00',
                '2018-09-19T04:30:00',
                '2018-09-19T05:30:00',
                '2018-09-19T06:30:00',
                '2018-09-19T07:30:00',
                '2018-09-19T08:30:00',
                '2018-09-19T09:30:00',
              ],
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              show: false,
            },
            fill: {
              colors: ['#f73164'],
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm',
              },
            },
            grid: {
              show: false,
              padding: {
                left: 0,
                right: -10,
                bottom: -50,
              },
            },
          },
          series: [
            {
              name: 'series1',
              data: [14, 12, 20, 20, 14, 22, 18, 26, 12, 18, 0],
            },
          ],
        },
      };
    },
    mounted() {
      this.getDataHeader();
    },
    methods : {
      async getDataHeader() {
        let data_header = await this.$store.dispatch("match_scoring/getDataHeader");
        this.dataHeader = data_header;
      },
      onCustomStyleSubmit(evt){
        evt.preventDefault();
        if(this.c_form.first_name !== '') {
          this.c_form_result.first_name = true;
        } else {
          this.c_form_result.first_name = false;
        }

        if(this.c_form.last_name !== '') {
          this.c_form_result.last_name = true;
        } else {
          this.c_form_result.last_name = false;
        }

        if(this.c_form.username !== '') {
          this.c_form_result.username = true;
        } else {
          this.c_form_result.username = false;
        }

        if(this.c_form.city !== '') {
          this.c_form_result.city = true;
        } else {
          this.c_form_result.city = false;
        }

        if(this.c_form.state !== '') {
          this.c_form_result.state = true;
        } else {
          this.c_form_result.state = false;
        }

        if(this.c_form.zip !== '') {
          this.c_form_result.zip = true;
        } else {
          this.c_form_result.zip = false;
        }
      },
    },
  };
</script>
<style scoped>
.chart {
  height: 400px;
}
</style>
